import React from "react";
import { Box, CircularProgress, Tab, Tabs, Typography } from "@mui/material";
import GradientCard from "./gradients/GradientCard";
import Slider from "./Slider";
import StyledTabIconBox from "./StyledTabIconBox";
import { errorMessages } from "../data/error-messages";

const TabPanel = ({ children, value, index }) => {
  return (
    <Box
      sx={{
        display: value === index ? "block" : "none",
        backgroundColor: "background.default",
        padding: "10px 20px",
      }}
    >
      {children}
    </Box>
  );
};

function CustomizerDrawerTabs({
  selectedTab,
  handleChangeTab,
  drawerConfig,
  sliderConfig,
  collectionsLoading,
  filteredCollections,
  selectedCollection,
  handleChangeCollection,
  filterValues,
}) {
  return (
    <>
      <Tabs variant="fullWidth" value={selectedTab ?? 0} onChange={handleChangeTab}>
        {Object.values(drawerConfig).map((category, index) => (
          <Tab
            key={index}
            label={
              <>
                <Typography variant="h3">{category.label}</Typography>
                <StyledTabIconBox>
                  <GradientCard
                    variant="circle"
                    background="#e9e9e9"
                    selected={index === selectedTab}
                    sx={{
                      "& > .MuiCard-root": {
                        padding: "0px",
                        margin: "5px",
                      },
                    }}
                  >
                    <img src={category.icon} />
                  </GradientCard>
                </StyledTabIconBox>
              </>
            }
          />
        ))}
      </Tabs>
      {Object.values(drawerConfig).map((category, index) => (
        <TabPanel key={index} index={index} value={selectedTab}>
          <Slider config={sliderConfig}>
            {(collectionsLoading ? [{}] : [...filteredCollections]).map((collection, i) => (
              <GradientCard
                key={i}
                variant="square"
                selected={selectedCollection === i}
                onClick={() => handleChangeCollection(i)}
                sx={{
                  "& > .MuiCard-root": {
                    padding: "10px",
                  },
                }}
              >
                {collectionsLoading && <CircularProgress />}
                {!collectionsLoading && (
                  <>
                    {selectedTab !== 1 && (
                      <Typography
                        variant="h4"
                        sx={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          width: "70px",
                          textAlign: "center",
                        }}
                      >
                        {collection.title}
                      </Typography>
                    )}
                    <Box
                      sx={{
                        flex: "1",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={collection.src}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                        }}
                      />
                    </Box>
                  </>
                )}
              </GradientCard>
            ))}
          </Slider>
          {!collectionsLoading &&
            !filteredCollections.length &&
            !!filterValues.length &&
            selectedTab >= 1 && (
              <Typography sx={{ paddingBlock: "16px" }}>{errorMessages.PATCHES_EMPTY}</Typography>
            )}
        </TabPanel>
      ))}
    </>
  );
}

export default React.memo(CustomizerDrawerTabs);
